import { DevelopmentalData } from "@/types/developmental";

export const age6Milestones: DevelopmentalData = {
  motor: [
    "Demonstrates smooth coordination",
    "Writes with good control",
    "Participates in sports",
    "Masters complex physical tasks",
    "Shows refined fine motor skills"
  ],
  language: [
    "Reads simple books",
    "Writes simple sentences",
    "Uses advanced vocabulary",
    "Follows complex instructions",
    "Expresses ideas clearly"
  ],
  cognitive: [
    "Solves simple math problems",
    "Understands time concepts",
    "Shows logical thinking",
    "Classifies objects",
    "Demonstrates memory skills"
  ],
  independent: [
    "Manages daily routine",
    "Handles basic responsibilities",
    "Shows time management",
    "Makes simple decisions",
    "Takes care of belongings"
  ],
  social: [
    "Forms close friendships",
    "Shows team spirit",
    "Understands rules",
    "Shows leadership qualities",
    "Manages emotions well"
  ]
};